import useImageUrl from 'hooks/useImageUrl';

export const BuyDialogPrint = ({ product }) => {
  const constructImageUrl = useImageUrl();

  return (
    <div className="flex flex-col items-center">
      <img
        src={constructImageUrl({
          img: product.zoom,
          width: 75,
          height: 100,
        })}
        alt=""
        className="mb-4 [height:100px] [width:75px]"
      />
      <p className="text-xl">"{product.name}" Print</p>
    </div>
  );
};
